<template>
  <div class="edit-texturetypes">
    <div class="sticky-header">
      <h1>Texture types</h1>
      <div class="sticky-header-button">
        <LoadingButton @click="save()" :loading="loading" :disabled="!formDirty">Opslaan</LoadingButton>
      </div>
    </div>

    <form class="default-form edit-texturetypes-form" @submit.prevent>
      <div class="default-form-field">
        <div class="default-form-field-glastypes">
          <div class="default-form-field-glastypes-header default-form-field-glastypes-edit-row">
            <span>Naam</span>
          </div>

          <div v-for="(t, i) in local" :key="t.__key" class="default-form-field-glastypes-edit-row">
            <input type="text" class="default-form-field-input" v-model.trim="t.name" placeholder="Type naam" />
            <button class="default-form-field-button" @click.prevent="remove(i)">
              <mdicon name="minus" class="default-form-field-button-icon" size="25" />
            </button>
          </div>

          <button class="default-form-field-button" @click.prevent="add()">
            <mdicon name="plus" class="default-form-field-button-icon" size="25" />
          </button>
        </div>
      </div>

      <div class="default-form-button">
        <LoadingButton @click="save()" :loading="loading" :disabled="!formDirty">Opslaan</LoadingButton>
      </div>
    </form>
  </div>
  
</template>

<script>
import isEqual from 'lodash.isequal'
import { mapGetters } from 'vuex'
import LoadingButton from '@/components/inputs/buttons/LoadingButton.vue'

export default {
  name: 'TextureTypes',
  components: { LoadingButton },
  data () {
    return {
      loading: false,
      local: [],
      original: [],
    }
  },
  computed: {
    ...mapGetters({ textureTypes: 'getTextureTypes' }),
    formDirty () {
      return !isEqual(
        this.original.map(x => ({ id: x.id || null, name: x.name || '' })),
        this.local.map(x => ({ id: x.id || null, name: x.name || '' }))
      )
    }
  },
  methods: {
    async prime() {
      await this.$store.dispatch('getTextureTypes')
      this.original = JSON.parse(JSON.stringify(this.textureTypes || []))
      // tag each line with a stable key for v-for
      this.local = this.original.map(t => ({ ...t, __key: t.id || Math.random().toString(36).slice(2) }))
    },
    add() {
      this.local.push({ id: null, name: '', __key: Math.random().toString(36).slice(2) })
    },
    remove(i) {
      this.local.splice(i, 1)
    },
    async save() {
      this.loading = true
      try {
        // prevent empty names
        const cleaned = this.local.filter(t => (t.name || '').trim().length > 0).map(({ id, name }) => ({ id, name: name.trim() }))
        await this.$store.dispatch('updateTextureTypes', cleaned)
        await this.prime()
      } finally {
        this.loading = false
      }
    }
  },
  created() { this.prime() }
}
</script>

<style lang="scss" scoped>
.edit-texturetypes {
  display: flex;
  flex-direction: column;
  padding: 25px;
  align-items: center;
  min-width: min(100%, 800px);

  &-form {
    padding: 25px 0px;
    gap: 50px;
    min-width: min(100%, 800px);
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1 { margin: 0; text-align: left; flex: 1; }
  &-button { flex-shrink: 0; margin-left: 20px; }
}
</style>